import React, { useState, useEffect, Fragment, useRef } from 'react';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import { connect } from 'react-redux';
import { message, Tag } from 'antd';
import axios from 'axios';

import ReactEcharts from '../../../Echarts/Echarts';
import localStorage from '../../../../../../utils/localStorage';
import { ErrorComponent, NoRecordComponent } from '../../../Utils';
import ModalView from './ModalView';
import {
  trendLabelTranslation,
  predictionsLegendsTranslation
} from '../../../../Utils/Adapter/translationAdapter';
import { getChartDataWithSelection, getChartDataWithoutSelection } from '../../../ChartCalls';
import { arrayOfObjects } from './mock.js';
import { config } from '../../../constant';
import { PREDICTIONS } from '../../../../../../commons/api.js';

const PredictedGraph = (props) => {
  const { translationCache } = props; // Ensure translationCache is defined from props
  const [option, setOption] = useState(getInitialOption(props));
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [feedbackForm, setFeedbackForm] = useState(props.feedbackFormData || {});
  const [refreshDateTime, setRefreshDateTime] = useState(''); // Track refresh time
  const [noDataInDB, setNoDataInDB] = useState(false); // Track no data state
  const [errorInAPI, setErrorInAPI] = useState(false); // Track error state
  let graphprops = props.graphprops;

  const abortController = useRef(new window.AbortController());
  let timeTicket = useRef(null);
  let requestCheck = true;
  const {
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
  } = props;
  useEffect(() => {
    getData();

    const refreshTime = props && props.graphprops &&props.graphprops.refreshTime ? props.graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck) {
        getData();
      }
    }, refreshTime);

    return () => {
      clearInterval(timeTicket);
        abortController.current.abort();
    };
  }, [props]);

  useEffect(() => {
    if (props.feedbackFormData !== feedbackForm) {
      setFeedbackForm(props.feedbackFormData);
    }
  }, [props.feedbackFormData]);

  const getData = async () => {
    let json = [];
    requestCheck = false;
    const optionClone = cloneDeep(option);

    // Set loading state if you want to show a loading indicator
    // setLoading(true); // Uncomment if you want to use loading state

    if (graphprops && graphprops.enableMock) {
      json = arrayOfObjects;
      requestCheck = true;
    } else {
      // Check for selection conditions
      if (graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)) {
              
        json = await getChartDataWithSelection({
          graphprops,
          DeviceCode : props.DeviceCode,
          selectionDate : props.selectionDate,
          selectionMonth :props.selectionMonth,
          selectionWeek :props.selectionWeek,
          shift :props.shift,
          selectionDateRange : props.selectionDateRange,
          dayMonthYear : props.dayMonthYear,
          abortController,
          dropdownSelection : props.dropdownSelection,
          dashboardPayload :props.dashboardPayload,
          AssetCode :props.AssetCode,
          selectionDateLive :props.selectionDateLive,
          currentTimeZone :props.currentTimeZone
            });
      } else {
        json = await getChartDataWithoutSelection({
          graphprops,
          abortController,
          dropdownSelection: props.dropdownSelection,
          DeviceCode: props.DeviceCode,
          TimeZone: props.currentTimeZone
        });
      }
    }

    if (Array.isArray(json)) {
      setData(json);
      updateChartOptions(json, optionClone, translationCache);
      setRefreshDateTime(moment().format('YYYY-MM-DD HH:mm:ss')); // Set refresh time
    } else {
      setNoDataInDB(true); // Set noDataInDB if no data is returned
    }

    // setLoading(false); // Uncomment if you want to use loading state
  };

  // const shouldFetchData = (graphprops) => {
  //   return (
  //     graphprops &&
  //     ((graphprops.DashboardLevelSelection === 'datePicker' ||
  //       graphprops.GraphLevelSelection === 'datePicker') &&
  //       selectionDate) ||
  //     (
  //       (graphprops.DashboardLevelSelection === 'monthPicker' ||
  //         graphprops.GraphLevelSelection === 'monthPicker') &&
  //       selectionMonth) ||
  //     (
  //       (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
  //         graphprops.GraphLevelSelection === 'dateRangePicker') &&
  //       selectionDateRange) ||
  //     (
  //       (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
  //         graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
  //       dayMonthYear) ||
  //     (
  //       (graphprops.DashboardLevelSelection === 'deviceSelection' ||
  //         graphprops.GraphLevelSelection === 'deviceSelection') &&
  //       DeviceCode)
  //   );
  // };

  const updateChartOptions = async (json, optionClone, translationCache) => {
    let series = [];
    if (props.graphprops.predictionsType === 'arrayOfArray') {
      optionClone.xAxis.data = json.map(item => moment.utc(item[0]).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm'));
      series = [
        {
          name: 'Anomaly',
          data: json.map(item => item[1]),
          type: 'scatter',
          symbolSize: () => 15
        },
        {
          symbolSize: 0,
          data: json.map(() => 4),
          type: 'line',
          lineStyle: { color: 'skyblue' }
        },
        {
          name: 'Actual',
          symbolSize: 12,
          data: json.map(item => item[2]),
          type: 'line',
          symbol: 'triangle',
          lineStyle: { color: 'skyblue' }
        }
      ];
    } else {
      optionClone.xAxis.data = json.map(item => moment.utc(item.DataTime).local().format('YYYY-MM-DD HH:mm'));
      series = [
        {
          name: translationCache['Predicted Abnormal'] || 'Predicted Abnormal',
          barWidth: '60%',
          data: json.map(item => (item && item.count && item.Future !== true ? item.count : 'null')),
          type: 'bar',
          color: 'steelblue'
        },
        {
          name: translationCache['Actual Abnormal'] || 'Actual Abnormal',
          symbolSize: 9,
          data: json.map(item => (item && item.count && item.count > 0 && item.status === 4 ? item.count + 1 : item.status === 4 && item.count === 0 ? 5 : 'null')),
          type: 'scatter',
          color: 'yellow'
        },
        {
          name: translationCache['Future Abnormal'] || 'Future Abnormal',
          barWidth: '60%',
          data: json.map(item => (item && item.Future ? item.count : 'null')),
          type: 'bar',
          color: 'red'
        }
      ];
    }

    series = await trendLabelTranslation(series, translationCache, props.language);
    const legends = await predictionsLegendsTranslation(optionClone.legend, translationCache, props.language);
    optionClone.legends = legends;
    optionClone.series = series;
    setOption(optionClone);
  };

  const onChartClick = (cellData) => {
    const { graphprops } = props;
    if (graphprops.predictionsType === 'arrayOfArray') {
      if (cellData.seriesType === 'scatter' && cellData.seriesIndex === 0) {
        const predictedObject = data.filter(predicted => moment.utc(predicted[0], 'YYYY-MM-DD HH:mm').local().format('YYYY-MM-DD HH:mm') === cellData.name);
        if (predictedObject[0] && predictedObject[0][3]) {
          props.summaryTable(predictedObject[0], graphprops.predictionsType);
        } else {
          message.warn(translationCache['No Data'] || 'No Data');
        }
      }
    } else {
      if (graphprops.predictionsType === 'arrayOfObject') {
        if (cellData.seriesType === 'bar' && cellData.seriesIndex === 0) {
          setModalVisible(true);
          const predictedObject = data.filter(predicted => moment.utc(predicted.time, 'YYYY-MM-DD HH:mm').local().format('YYYY-MM-DD HH:mm') === cellData.name);
          if (predictedObject[0] && predictedObject[0].tagsList && predictedObject[0].tagsList.length > 0) {
            props.summaryTable(predictedObject[0], graphprops.predictionsType);
          }

          if (predictedObject[0] && predictedObject[0].notification) {
            if (predictedObject[0].tagsList && predictedObject[0].tagsList.length > 0) {
              props.feedbackForm(cloneDeep(predictedObject[0].notification));
            } else {
              setFeedbackForm(predictedObject[0].notification);
              setModalVisible(true);
            }
          } else {
            props.feedbackForm({});
          }
        }
      }
    }
  };

  const handleOk = (feedbackText) => {
    const payload = {
      ...feedbackText,
      Timestamp: moment(feedbackText.Timestamp, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
      'Notification Id': feedbackText.NotificationId,
      'Tag Description': feedbackText.TagDescription
    };
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'POST',
      url: `${PREDICTIONS.UPDATE}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    return axios(deviceTypeObject)
      .then(() => {
        setModalVisible(false);
        props.refereshData('close');
      })
      .catch(() => {
        setErrorInAPI(true); // Set error state if API call fails
      });
  };

  const handleCancel = () => {
    setModalVisible(false);
    props.refereshData('close');
  };

  const onEvents = {
    click: (cellData) => onChartClick(cellData)
  };

  return (
    <span>
      <Fragment>
        {props.graphprops && props.graphprops.checked ? (
          <Tag className="graphTag" color="blue">
            {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
          </Tag>
        ) : null}
        {noDataInDB || errorInAPI ? (
          noDataInDB ? (
            <NoRecordComponent />
          ) : (
            <ErrorComponent />
          )
        ) : (
          <ReactEcharts
            onEvents={onEvents}
            option={option}
            className="react_for_echarts"
          />
        )}
      </Fragment>

      {modalVisible && (
        <ModalView
          feedbackForm={feedbackForm}
          open={modalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        />
      )}
    </span>
  );
};

const getInitialOption = (props) => {
  const { translationCache } = props;
  return {
    title: {
      left: 'center',
      textStyle: {
        color: 'white',
        align: 'center'
      }
    },
    toolbox: {
      showTitle: false,
      itemSize: 25,
      feature: {
        saveAsImage: {
          title: 'download',
          backgroundColor: 'black',
          name: props.graphprops.title,
          iconStyle: {
            borderColor: '#8c8c8c',
            borderWidth: 2
          }
        }
      }
    },
    xAxis: {
      type: 'category',
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      axisTick: {
        lineStyle: {
          color: 'white'
        }
      },
      axisLabel: {
        color: 'white',
        formatter: (value) => moment(value).format('HH:mm')
      }
    },
    yAxis: {
      splitLine: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'white'
        }
      },
      axisTick: {
        lineStyle: {
          color: 'white'
        }
      },
      axisLabel: {
        color: 'white'
      }
    },
    dataZoom: [
      {
        // startValue: '2020-04-20'
      },
      {
        type: 'inside'
      }
    ],
    legend: {
      right: 60,
      data: props.graphprops && props.graphprops.predictionsType === 'arrayOfObject'
        ? [
          translationCache['Predicted Abnormal'] || 'Predicted Abnormal',
          translationCache['Actual Abnormal'] || 'Actual Abnormal',
          translationCache['Future Abnormal'] || 'Future Abnormal'
        ]
        : ['Anomaly', 'Actual'],
      textStyle: {
        color: 'white'
      }
    }
  };
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(PredictedGraph);